<script>
	///Loaded With Citibot Test Staging
	const style = document.createElement('style')
	;(style.innerHTML =
		'iframe#citibot {    box-shadow:0 0 5px grey;    border-radius : 10px;    border: none !important;    z-index: 2147483000;    position: fixed;    bottom: 13vh;    right: 20px;    width: 450px;    height: calc(100vh - 150px);    opacity: 0;    display: none;    transition: opacity 0.3s ease 0s; }  div#root {    font-size: 100%;    font-style: normal;    letter-spacing: normal;    font-stretch: normal;    font-weight: normal;    text-align-last: initial;    text-indent: 0px;    text-shadow: none;    text-transform: none;    alignment-baseline: baseline;    animation-play-state: running;    backface-visibility: visible;    background-color: transparent;    background-image: none;    baseline-shift: baseline;    bottom: auto;    -webkit-box-decoration-break: slice;    box-shadow: none;    box-sizing: content-box;    caption-side: top;    clear: none;    clip: auto;    color: inherit;    column-count: auto;    column-fill: balance;    column-gap: normal;    column-width: auto;    content: normal;    counter-increment: none;    counter-reset: none;    cursor: auto;    direction: ltr;    display: inline;    dominant-baseline: auto;    empty-cells: show;    float: none;    height: auto;    -webkit-hyphenate-character: auto;    hyphens: manual;    image-rendering: auto;    left: auto;    line-height: inherit;    max-height: none;    max-width: none;    min-height: 0px;    min-width: 0px;    opacity: 1;    orphans: 2;    outline-offset: 0px;    page: auto;    perspective: none;    perspective-origin: 50% 50%;    pointer-events: auto;        quotes: none;    resize: none;    right: auto;    size: auto;    table-layout: auto;    top: auto;    transform: none;    transform-origin: 50% 50% 0px;    transform-style: flat;    unicode-bidi: normal;    vertical-align: baseline;    white-space: normal;    widows: 2;    width: auto;    word-break: normal;    word-spacing: normal;    overflow-wrap: normal;    z-index: auto;    text-align: start;    -webkit-font-smoothing: antialiased;    font-variant: normal;    text-decoration: none;    border-width: 0px;    border-style: none;    border-color: transparent;    border-image: initial;    border-radius: 0px;    list-style: disc outside none;    margin: 0px;    overflow: visible;    padding: 0px;    page-break-after: auto;    page-break-before: auto;    page-break-inside: auto;    display: flex;    justify-content:center;  }  @keyframes appear {    from {        transform: translateY(40px);    }    to {        transform: translateY(0);    }}@keyframes appear_out {    from {        transform: translateY(0px);    }    to {        transform: translateY(40px);    }}.citibot_in{    animation: appear_out 0.4s ease-out;}.citibot_out{    animation: appear 0.4s ease-out;}@media only screen and (max-width: 430px) {    #citibot{        width: 90vw!important;        height: calc(100vh - 180px);    }}@media only screen and (max-width: 380px) {    #citibot{        bottom: 14vh!important;        height: calc(100vh - 180px);    }}@media only screen and (max-width: 340px) {    #citibot{        bottom: 16vh!important;        height: calc(100vh - 180px);    }}  '),
		document.head.appendChild(style),
		(window.onload = async function () {
			const n = document.createElement('div'),
				t = document.createElement('iframe'),
				e = document.createElement('img')
			let o = !1
			;/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
				navigator.userAgent
			) && (o = !0),
				(e.src = 'https://webchat-backend-staging.s3.amazonaws.com/bot.svg')
			var a = '',
				i = ''
			e.onclick = function () {
				const n = document.getElementById('citibot')
				if (
					((n.style.opacity =
						'0' === window.getComputedStyle(n, null).getPropertyValue('opacity')
							? '1'
							: '0'),
					'0' === document.getElementById('citibot').style.opacity)
				)
					window.frames.citibot.postMessage('cancel', '*'),
						(document.getElementById('citibot').style.display = 'none'),
						(e.src =
							a || 'https://webchat-backend-staging.s3.amazonaws.com/bot.svg'),
						(t.className = 'citibot_in')
				else {
					t.src || (t.src = 'https://webchat.staging.citibot.io?org_id=23')
					var o = Date.now(),
						r = setInterval(() => {
							console.log('set interval called'),
								Date.now() - o > 2e3
									? clearInterval(r)
									: window.frames.citibot.postMessage(JSON.stringify(i), '*')
						}, 50)
					;(document.getElementById('citibot').style.display = 'block'),
						(e.src =
							'https://webchat-backend-staging.s3.amazonaws.com/cross.svg'),
						(t.className = 'citibot_out'),
						i && window.frames.citibot.postMessage(JSON.stringify(i), '*')
				}
			}
			await fetch(
				'https://webchat-backend.staging.citibot.io/organizations/23/image'
			)
				.then(async (n) => {
					const t = await n.json()
					;(i = t.data),
						(a = t.data.logo),
						(e.src = a
							? t.data.logo
							: 'https://webchat-backend-staging.s3.amazonaws.com/bot.svg'),
						t.data.phone_number
				})
				.catch(() => {
					e.src = 'https://webchat-backend-staging.s3.amazonaws.com/bot.svg'
				})
			;(e.style = 'width:100px;height:100px !important;'),
				o && (e.style = 'width:100px;height:100px !important;'),
				(e.alt = 'citibot webchat'),
				(t.id = 'citibot'),
				(t.name = 'citibot'),
				(n.id = 'root'),
				(n.style =
					'position: fixed;bottom: 30px;right: 50px; cursor: pointer; z-index: 999999'),
				n.appendChild(e),
				document.getElementsByTagName('body')[0].append(t),
				document.getElementsByTagName('body')[0].append(n)
		})
</script>

<main>
	<div id="citibot-header">
		<img src="/citibot-logo.png" alt="citibot" />
		<h1>Webchat</h1>
	</div>
	<p>
		To begin testing your webchat, click the icon in the bottom right corner of
		the webpage!
	</p>
</main>

<style>
	main {
		text-align: center;
		padding: 1em;
		max-width: 100%;
		margin: 0 auto;
	}

	#citibot-header {
		justify-content: center;
		display: flex-block;
		width: 100%;
	}

	h1 {
		color: #48c3e3;
		text-transform: uppercase;
		font-size: 6em;
		font-weight: 300;
		margin: auto;
	}

	p {
		margin-top: 100px;
	}

	@media (min-width: 640px) {
		main {
			max-width: 100%;
		}
	}
</style>
